import * as React             from 'react'
import { connect }            from 'react-redux'
import { bindActionCreators } from 'redux'

import { User }                                           from '../../api'
import { ApplicationState, genUsersDeleteRequest }        from '../../redux'
import withDialogControls, { InjectedDialogControlProps } from '../hocs/withDialogControls'
import UserInfoPopup                                      from './UserInfoPopup'
import UserListItem                                       from './UserListItem'

interface UserListEntryProps {
  user: User
}

const mstp = (state: ApplicationState, passedProps: UserListEntryProps) => ({
  communication: genUsersDeleteRequest(passedProps.user.id).communicationSelector(state)
})

const mdtp = (dispatch, passedProps: UserListEntryProps) => bindActionCreators(
  {
    deleteUser: genUsersDeleteRequest(passedProps.user.id).actionCreator,
  },
  dispatch,
)

type Props =
  UserListEntryProps
  & InjectedDialogControlProps
  & ReturnType<typeof mdtp>
  & ReturnType<typeof mstp>

const UserListEntry = ({
  close,
  open,
  isOpen,
  user,
  deleteUser,
  communication,
}: Props) => {

  /*
   * don't render the popup if the account is not active since
   * there's no data to be displayed in there anyways and it
   * will most likely cause errors with the popup trying to
   * access deeply nested properties
   * */
  const infoPopup = user.account.active && (
    <UserInfoPopup
      close={close}
      isOpen={isOpen}
      user={user}
    />
  )

  return (
    <>
      {infoPopup}
      <UserListItem
        onDelete={deleteUser}
        deleteCommunication={communication}
        onInfoClick={open}
        user={user}
      />
    </>
  )
}

export default connect(mstp, mdtp)(withDialogControls(UserListEntry))



// WEBPACK FOOTER //
// ./src/components/molecules/UserListEntry.tsx